import React, { useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { TextField } from '@material-ui/core';
import Button from 'components/CustomButtons/Button.js';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import { WithApp } from 'contexts/appContext';
import { AccountBalanceWallet, Close } from '@material-ui/icons';

const useStyles = makeStyles({
  grid: {
    fontWeight: 'bold',
    textAlign: 'end'
  }
});

export default WithApp(function Cash(props) {
  const classes = useStyles();
  const formRef = useRef();

  const { type, amountPay, dataPayment, methodPay, handleMethod, processPayment } = props;

  return (
    <>
      <GridItem xs={6}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleMethod('CH', true);
            processPayment(type, formRef);
          }}
          ref={formRef}
          id="formCH"
        >
          <GridContainer>
            {/* <GridItem xs={12} md={6} lg={6}>
              <TextField
                key={methodPay.CH}
                label="Cuenta de mayor"
                type="number"
                name="CashAcct"
                fullWidth
                defaultValue={dataPayment?.CH?.CashAcct || '10111001'}
                margin="normal"
                required
                inputProps={{
                  min: 0
                }}
                disabled
              />
            </GridItem> */}
            <GridItem xs={12} md={6} lg={6} className={classes.grid}>
              <TextField
                key={amountPay}
                name="CashSum"
                fullWidth
                label="Monto a pagar"
                type="number"
                defaultValue={dataPayment?.CH?.CashSum || amountPay.toFixed(2)}
                margin="normal"
                onKeyPress={(e) => {
                  var key = window.event ? e.which : e.keyCode;
                  if (key === 101) {
                    return e.preventDefault();
                  }
                }}
                inputProps={{
                  min: 0,
                  step: 0.0001
                }}
                required
                disabled={methodPay.CH}
              />
            </GridItem>
          </GridContainer>
        </form>
      </GridItem>
      <GridItem xs={6} style={{ display: 'flex', alignItems: 'flex-end' }}>
        <Button
          key={methodPay.CH}
          form="formCH"
          type="submit"
          color={
            methodPay.CH === false
              ? props.themeContext.buttonColor
              : props.themeContext.buttonColorDanger
          }
          size="sm"
        >
          {methodPay.CH === false ? (
            <>
              <AccountBalanceWallet />
              Agregar
            </>
          ) : (
            <>
              <Close />
              Quitar
            </>
          )}
        </Button>
      </GridItem>
    </>
  );
});
